module.exports = __webpack_public_path__ + "static/media/documentation.6687f4e0.png";